import { Link, useLocation } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText } from 'ui';

import { isRouteActive } from './Sidebar';
import { useSidebarContext } from './SidebarContext';

export type SidebarLinkProps = {
  label: string;
  href: string;
  icon?: React.ReactNode;
  indent?: boolean;
  isLegacy?: boolean;
  title?: string;
  dense?: boolean;
};

export const SidebarLink = ({
  title,
  label,
  href,
  icon,
  indent = false,
  isLegacy = true,
  dense = true,
}: SidebarLinkProps) => {
  const { pathname } = useLocation();
  const { onClose } = useSidebarContext();
  const isActive = isRouteActive(pathname, href);
  const commonProps = {
    dense: dense,
    onClick: onClose,
    selected: isActive,
    sx: {
      ...(indent && { pl: 4 }),
      borderRadius: 1,
    },
  };

  const content = (
    <>
      {icon !== null && icon !== undefined && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          fontWeight: isActive ? 'bold' : 'regular',
        }}
      />
    </>
  );

  if (!isLegacy) {
    return (
      <ListItemButton {...commonProps} component={Link} to={href} title={title}>
        {content}
      </ListItemButton>
    );
  }

  return (
    <ListItemButton {...commonProps} component="a" href={href} title={title}>
      {content}
    </ListItemButton>
  );
};
